import { IEcole } from 'app/shared/model/ecole.model';
import React from 'react';

type Props = {
  comptes: readonly IEcole[];
  shuffle?: number;
};

const useRandomColors = ({ comptes, shuffle = 1 }: Props) => {
  const randomBackgroundColor: string[] = [];
  const usedColors = new Set();

  const dynamicColors = function () {
    const r = Math.floor(Math.random() * shuffle * 255);
    const g = Math.floor(Math.random() * 255);
    const b = Math.floor(Math.random() * 255);
    const color = 'rgb(' + r + ',' + g + ',' + b + ')';

    if (!usedColors.has(color)) {
      usedColors.add(color);
      return color;
    } else {
      return dynamicColors();
    }
  };

  for (const i of comptes) {
    randomBackgroundColor.push(dynamicColors());
  }
  return { randomBackgroundColor };
};

export default useRandomColors;
